import template from './helloPackEmailField.html';
import controller from './helloPackEmailFieldCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    client: '<',
    value: '<',
    key: '<',
    isRequired: '<',
    onUpdate: '&',
  },
};
